export const containerStyles = 'relative flex sm:flex-row flex-col-reverse w-full justify-center rounded-[45px] p-3 gap-10';
export const textStyles = 'gilroy text-[#313131]';
export const subTextStyles = 'lg:text-[24px] text-[20px] text-[#8a8a8a] mb-5 font-[100]';
export const buttonStyles = 'bg-[#000] text-white p-3 rounded-3xl text-lg font-[100]';
export const editIconStyles = 'absolute top-[25px] right-[25px]';
